import React from 'react'
import { OrderListComp } from '../../../../components/main/login/mypage/orderlist/OrderListComp'

export const OrderList = () => {
  return (
    <div>
      <OrderListComp/>
    </div>
  )
}
